<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200" flat color="transparent">
          <v-card-title class="mb-10">
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-blog-categories'"
              :title="
                getTitle ? `${getTitle} категория блога` : `Создать категорию блога`
              "
            />
          </v-card-title>
          <v-card-text>
            <PageContent>
              <v-container>
                <InputTitleSlug
                  :is-loading="loading || disabled"
                  :title="fields.title"
                  :title-error="validationErrors.title"
                  :slug="fields.slug"
                  :slug-error="validationErrors.slug"
                  :isSlugEnabled="!isNew"
                  @change:title="fields.title = $event"
                  @change:slug="fields.slug = $event"
                  @input:slug="$v.fields.slug.$touch"
                />
                <v-row>
                  <v-col cols="12">
                    <span>Анонс (<TranslationIcon />)</span>
                    <v-text-field
                      outlined
                      :disabled="disabled"
                      :loading="loading"
                      v-model="fields.announcement"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <SeoSettings
                      :data="data"
                      :loading="loading || disabled"
                      @on-input-seo="fields = Object.assign({}, fields, $event)"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          v-if="isNew"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="isNew"
          :is-loading="loading"
          :iis-show-btn-submit="disabled"
          :entity-type="'blogCategory'"
          :sortOrder="fields.sortOrder"
          :language="language"
          :translations="fields.translations"
          @delete="$emit('delete-blog-category')"
          @cancel="$router.push({ name: 'page-blog-categories' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        />
        <ManageSidePanel
          v-else-if="data"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :iis-show-btn-submit="disabled"
          :entity-id="data.id"
          :entity-type="'blogCategory'"
          :language="language"
          :translations="fields.translations"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-blog-category')"
          @cancel="$router.push({ name: 'page-blog-categories' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        />
      </v-col>
    </v-row>
  </form>
</template>
<script>
import { defaultDateFormat } from '@/configs/date.js'
import FormAbstract from '@/components/abstract/form'
import validationRules from './validation-rules'
import ManageSidePanel from '@/components/manage-side-panel'
import SeoSettings from '@/components/seo-settings'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import { mixForm } from '@/utils/form.mix.js'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormBlogCategory',
  defaultDateFormat,
  validationRules,
  extends: FormAbstract,
  mixins: [validationTranslations, mixForm],
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    ManageSidePanel,
    SeoSettings,
    FormHeader,
    ProgressCircular
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      fields: {
        title: null,
        slug: undefined,
        announcement: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoMetaKeywords: null,
        seoDisallowIndex: false,
        seoRelCanonical: null,
        seoOgImage: null,
        translations: { ru: { isEnabled: true } },
        sortOrder: null
      }
    }
  },
  computed: {
    getTitle () {
      if (this.data) {
        return this.data?.title || ''
      }
      return null
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    }
  },
  methods: {
    async submit (data) {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.seoOgImage

      this.$emit('submit', payload)
    }
  },
  watch: {
    data (data) {
      if (data) {
        this.populate(data)
      }
    }
  }
}
</script>
